export const DASHBOARD_ANALYTICS_LIST_REQUEST = 'DASHBOARD_ANALYTICS_LIST_REQUEST';
export const DASHBOARD_ANALYTICS_LIST_SUCCESS = 'DASHBOARD_ANALYTICS_LIST_SUCCESS';
export const DASHBOARD_ANALYTICS_LIST_FAIL = 'DASHBOARD_ANALYTICS_LIST_FAIL';